export const version = '2.7.8-rc1';
